// src/components/_global/Header.js

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useEffect, useState } from "react";
import Styles from "../../styles/_global/Styles";
import LiquidGlass from "../LiquidGlass";
import MenuContent from "./NavTabs";
import ProfileButton from "./ProfileButton";

export default function Header() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // track whether page is scrolled away from top
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    if (!isMobile) return; // only on mobile

    const handleScroll = () => {
      setScrolled(window.pageYOffset > 0);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    // initialize
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isMobile]);

  // desktop always dark; mobile: light at top, dark once you scroll
  const logoSrc = isMobile
    ? scrolled
      ? "/assets/logo-light.svg"
      : "/assets/logo-light.svg"
    : "/assets/logo-dark.svg";

  return (
    <LiquidGlass
    frostOpacity={0.1}
    frosted={true}
      sx={{
        p: 0.8,
        borderRadius: '0px 0px 8px 8px',
        position: { xs: "sticky", md: "static" },
        top: { xs: 0, md: "auto" },
        zIndex: theme.zIndex.appBar,
        boxShadow: "0 1px 10px rgba(0,0,0,0.1)"
      }}
      altComponent={<Box />}
      altSx={{
        ...Styles.Header.sx,
        width: "100%",
        position: { xs: "sticky", md: "static" },
        top: { xs: 0, md: "auto" },
        zIndex: theme.zIndex.appBar,
        boxShadow: { xs: "0 1px 1px rgba(0,0,0,0.05)", md: "none" },
        pt: { xs: 1, md: 2 },
        pb: 0,
        mb: 0,
      }}
    >
      <Container disableGutters={isMobile} maxWidth={isMobile ? false : "lg"}>
        <Stack
          direction="row"
          alignItems="center"
          spacing={2}
          sx={{ width: "100%", boxSizing: "border-box", pt: 1.5, pb: 0 }}
        >
          {/* Logo */}
          <Box
            component="img"
            src={logoSrc}
            alt={process.env.REACT_APP_NAME}
            title={process.env.REACT_APP_NAME}
            sx={{
              ...Styles.Header.LogoBox.sx,
              width: { xs: 90, md: 130 },
              position: "relative",
              top: "-8px",
              right: { md: "-5px" },
              display: "block",
            }}
          />

          {/* Desktop nav only */}
          <Box sx={{ display: { xs: "none", md: "flex" }, flexGrow: 1 }}>
            <MenuContent />
          </Box>

          {/* Profile button — on mobile, takes up remaining space */}
          <Box
            sx={{
              display: "flex",
              flexGrow: { xs: 1, md: 0 },
              justifyContent: "flex-end",
              position: "relative",
              top: "-8px",
              boxSizing: "border-box",
            }}
          >
            <ProfileButton />
          </Box>
        </Stack>
      </Container>
    </LiquidGlass>
  );
}
